// src/lib/logger.ts
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from './applicationInsights';
import { setTelemetryUser, clearTelemetryUser } from './applicationInsights';

type LogProperties = Record<string, string | number | boolean | undefined | null>;

export const logger = {
  info(message: string, properties?: LogProperties) {
    appInsights.trackTrace({
      message,
      severityLevel: SeverityLevel.Information,
      properties,
    });
  },

  warning(message: string, properties?: LogProperties) {
    appInsights.trackTrace({
      message,
      severityLevel: SeverityLevel.Warning,
      properties,
    });
  },

  error(error: unknown, properties?: LogProperties) {
    const normalizedError =
      error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown frontend error');

    appInsights.trackException({
      exception: normalizedError,
      severityLevel: SeverityLevel.Error,
      properties,
    });
  },

  event(name: string, properties?: LogProperties) {
    appInsights.trackEvent({
      name,
      properties,
    });
  },

  /** Correlate subsequent telemetry to a user by id (no PII). */
  setUser(userId: string | number) {
    setTelemetryUser(userId);
  },

  /** Stop user correlation (logout / session expiry). */
  clearUser() {
    clearTelemetryUser();
  },
};